import GreenBoxCustomerNamesLine from './GreenBoxCustomerNamesLine';

export default GreenBoxCustomerNamesLine;
